export const maturity_options = [
  {
    label: "Select",
    value: "select",
  },
  {
    label:
      "TRL 1-2: My system is currently at the basic principles and initial concept stage",
    value:
      "TRL 1-2: My system is currently at the basic principles and initial concept stage",
  },
  {
    label:
      "TRL 3-6: My system is currently at the proof of concept and development stage",
    value:
      "TRL 3-6: My system is currently at the proof of concept and development stage",
  },
  {
    label:
      "TRL 7-9: My system is currently at the demonstration and deployment stage",
    value:
      "TRL 7-9: My system is currently at the demonstration and deployment stage",
  },
];

export const easa_system_levels = [
  {
    level: "1A",
    title: "Human Augmentation",
    sub_title: '"As-is" Today',
    description:
      "Enhanced information. No significant impact on the the operation or the end user.",
  },
  {
    level: "1B",
    title: "Human Assistance",
    sub_title: "Decision Support",
    description:
      "The AI is a cognitive assistant that helps optimise decision-making.",
  },
  {
    level: "2A",
    title: "Human AI-Teaming Cooperation",
    sub_title: "Task Owner",
    description:
      "Tasks allocated to the AI. Explainability (XAI) and some human-AI communication are required.",
  },
  {
    level: "2B",
    title: "Human AI Teaming Collaboration",
    sub_title: "Goal Sharing",
    description:
      "The AI negotiates with human towards common goals. More explainability and dialogue required.",
  },
  {
    level: "3A",
    title: "More Autonomous AI",
    sub_title: "System Control",
    description:
      'The AI is "running the show" unsupervised, human intervenes if required.',
  },
  {
    level: "3B",
    title: "Fully Autonomous AI",
    sub_title: "AI Alone",
    description:
      "The AI running everything with no human interventio except maintenance and shutdown.",
  },
];
